define('services/OrganizationService',['require','lib/backbone/Backbone.Mixins.Transport.API'],function(require) {

  var API = require('lib/backbone/Backbone.Mixins.Transport.API');

  return {

    getOrganizations: function() {
      return API.request('get', '/org/');
    },

    updateOrganization: function(orgId, attributes) {
      return API.request('put', '/org/{0}'.format(orgId), attributes);
    }

  };

});

